import { PricingPanel, OutboundLink } from '@/components/PricingPanel'

const singleLink: OutboundLink[] = [
	{ label: 'Apply Now', href: 'https://example.com/apply' }
]

const twoLinks: OutboundLink[] = [
	{ label: 'Apply Now', href: 'https://example.com/apply' },
	{ label: 'Schedule a Tour', href: 'https://example.com/tour' }
]

const threeLinks: OutboundLink[] = [
	{ label: 'Apply Now', href: 'https://example.com/apply' },
	{ label: 'Schedule a Tour', href: 'https://example.com/tour' },
	{ label: 'View Virtual Tour', href: 'https://example.com/video' }
]

const manyLinks: OutboundLink[] = [
	{ label: 'Contact Us', href: 'https://example.com/contact' },
	{ label: 'Schedule a Tour', href: 'https://example.com/tour' },
	{ label: 'View Virtual Tour', href: 'https://example.com/video' },
	{ label: 'Get Directions', href: 'https://example.com/directions' },
	{ label: 'Download Brochure', href: 'https://example.com/brochure' }
]

export function PricingPanelSandbox () {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── No outbound links ── */}
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
					No outbound links
				</h3>
				<p className='spaces:text-14/24 spaces:font-default spaces:text-content-3'>
					Primary action only — no secondary buttons.
				</p>
				<div className='spaces:max-w-624'>
					<PricingPanel
						moveInDate='2025-10-16'
						leaseTerm='12 Mo.'
						totalPrice='$12,345.67–$12,345.67'
						baseRent='$12,345'
						applicationFee='$12.34'
						moveInCost='$12,345.67'
						moveOutCost='$123.34'
						onEditLease={() => alert('Edit lease')}
						onApply={() => alert('Primary Action')}
					/>
				</div>
			</div>

			{/* ── Single outbound link ── */}
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
					Single outbound link
				</h3>
				<p className='spaces:text-14/24 spaces:font-default spaces:text-content-3'>
					One link renders next to the primary action as a brand outline button.
				</p>
				<div className='spaces:max-w-624'>
					<PricingPanel
						moveInDate='2025-10-16'
						leaseTerm='12 Mo.'
						totalPrice='$12,345.67–$12,345.67'
						baseRent='$12,345'
						applicationFee='$12.34'
						moveInCost='$12,345.67'
						moveOutCost='$123.34'
						onEditLease={() => alert('Edit lease')}
						onApply={() => alert('Primary Action')}
						outboundLinks={singleLink}
					/>
				</div>
			</div>

			{/* ── Two outbound links ── */}
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
					Two outbound links
				</h3>
				<p className='spaces:text-14/24 spaces:font-default spaces:text-content-3'>
					First link sits next to the primary action. Second link appears below as a
					small content2 stroke button.
				</p>
				<div className='spaces:max-w-624'>
					<PricingPanel
						moveInDate='2025-10-16'
						leaseTerm='12 Mo.'
						totalPrice='$12,345.67–$12,345.67'
						baseRent='$12,345'
						applicationFee='$12.34'
						moveInCost='$12,345.67'
						moveOutCost='$123.34'
						onEditLease={() => alert('Edit lease')}
						onApply={() => alert('Primary Action')}
						outboundLinks={twoLinks}
					/>
				</div>
			</div>

			{/* ── Three outbound links ── */}
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
					Three outbound links
				</h3>
				<p className='spaces:text-14/24 spaces:font-default spaces:text-content-3'>
					First link beside primary action; two additional links in secondary row
					below.
				</p>
				<div className='spaces:max-w-624'>
					<PricingPanel
						moveInDate='2025-10-16'
						leaseTerm='12 Mo.'
						totalPrice='$12,345.67–$12,345.67'
						baseRent='$12,345'
						applicationFee='$12.34'
						moveInCost='$12,345.67'
						moveOutCost='$123.34'
						onEditLease={() => alert('Edit lease')}
						onApply={() => alert('Primary Action')}
						outboundLinks={threeLinks}
					/>
				</div>
			</div>

			{/* ── Many outbound links ── */}
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
					Many outbound links
				</h3>
				<p className='spaces:text-14/24 spaces:font-default spaces:text-content-3'>
					First link beside primary action; four additional links wrap in secondary
					row below.
				</p>
				<div className='spaces:max-w-624'>
					<PricingPanel
						moveInDate='2025-10-16'
						leaseTerm='12 Mo.'
						totalPrice='$12,345.67–$12,345.67'
						baseRent='$12,345'
						applicationFee='$12.34'
						moveInCost='$12,345.67'
						moveOutCost='$123.34'
						onEditLease={() => alert('Edit lease')}
						onApply={() => alert('Primary Action')}
						outboundLinks={manyLinks}
					/>
				</div>
			</div>

			{/* ── No outbound links, hasFees=false ── */}
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
					No fees, no outbound links
				</h3>
				<p className='spaces:text-14/24 spaces:font-default spaces:text-content-3'>
					Simplified pricing with base rent only and no secondary actions.
				</p>
				<div className='spaces:max-w-624'>
					<PricingPanel
						moveInDate='2025-10-16'
						leaseTerm='12 Mo.'
						totalPrice='$12,345'
						hasFees={false}
						onEditLease={() => alert('Edit lease')}
						onApply={() => alert('Primary Action')}
					/>
				</div>
			</div>
		</div>
	)
}
